<div class="edit-card" [formGroup]="form()">
  <rt-icon
    name="drag-vertical"
    class="drag-handle"
    [class.disabled]="!isDraggable()"
    [colorToken]="dragHandleToken()"
    [hasAutoHeight]="true"
    cdkDragHandle
  />
  <div class="edit-fields">
    <div class="field">
      <span class="field-label">{{
        'tlc.positions.position_history_dialog.position_label' | translate
      }}</span>
      <rt-select2 #positionSelect formControlName="positionGuid" [items]="positionItems()">
        <rt-select-trigger
          [placeholder]="'tlc.positions.position_history_dialog.select_position' | translate"
        />
        <ng-template
          [rtSelectListItem]="positionSelect"
          let-selectCtrl
          let-item="item"
          let-isHoverState="isHoverState"
        >
          <rt-dropdown-item
            (click)="selectCtrl.select$.next(item)"
            [class.hover]="isHoverState"
            [isSelected]="selectCtrl.itemSelector.isSelected(item)"
          >
            <span>{{ item.label }}</span>
            @if (item.badge) {
              <rt-badge
                [iconName]="item.badge.icon"
                [color]="item.badge.color"
                [text]="item.badge.label"
                margin-left-small-x
              />
            }
          </rt-dropdown-item>
        </ng-template>
      </rt-select2>
    </div>
    <div class="field">
      <span class="field-label">{{
        'tlc.positions.position_history_dialog.start_date_label' | translate
      }}</span>
      <rt-input
        #dateOrigin="rtOverlayOrigin"
        rt-overlay-origin
        class="date-input"
        variant="rounded"
        [value]="startDateLabel() ?? ''"
        [placeholder]="'tlc.positions.position_history_dialog.select_date' | translate"
        [hasDropdownIndicator]="true"
        [readOnly]="true"
        (click)="dateDropdown.open = !dateDropdown.open"
      >
        <rt-icon prefix name="calendar-blank" />
      </rt-input>

      <ng-template
        #dateDropdown="rtConnectedOverlay"
        [origin]="dateOrigin"
        (backdropClick)="dateDropdown.open = false"
        rt-connected-overlay
        hasBackdrop
      >
        <rt-dropdown (click)="$event.stopPropagation()">
          <rt-date-picker
            [formControl]="startDateControl()"
            [direction]="dateDirection()"
            [blackout]="dateBlackout()"
            (valueChanged)="dateDropdown.open = false"
          />
        </rt-dropdown>
      </ng-template>
    </div>
  </div>
  @if (showDelete()) {
    <rt-icon-button iconName="delete" variant="plain" (click)="deleteClicked.emit()" />
  }
</div>
